export const PEOPLE = 'shared/people/page'
export const PERSON = 'shared/people/edit'
export const ADD_PERSON = 'shared/people/add'
export const UPDATE_PERSON = 'shared/people/update'
export const DELETE_PERSON = 'shared/people/delete'
export const SET_PEOPLE_DESCASC = 'shared/people/setDescAsc'
export const SET_PEOPLE_ORDER = 'shared/people/setOrder'
export const SET_PEOPLE_FILTERS = 'shared/people/setFilters'
export const RESET_PEOPLE_FILTERS = 'shared/people/resetFilters'
